<template>
    <b-modal title="Request Unauthorised Copy" hide-footer id="requestsModal">
        <div class="modal-body">
            <b-form class="">
                <b-row>
                    <b-col cols="6">
                        <b-form-group id="name" label="Copy Holder Name" label-for="name-input">
                            <b-form-input id="name-input" v-model="name" placeholder="Name of copy holder" required></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group id="email" label="Copy Holder Email" label-for="email-input">
                            <b-form-input id="email-input" v-model="email" type="email" placeholder="Copy holder email" required></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col class="mt-3" cols="12">
                        <b-form-group id="reason" label="Reason" label-for="reason-input">
                            <b-form-textarea id="reason-input" v-model="reason_text" rows="4" no-resize placeholder="Reason for copy request"></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                
            </b-form>
            <div class="mt-4" style="text-align: center;">
                <b-button
                @click="saveRequest"
                :disabled="disableButton"
                :variant="disableButton ? 'danger' : 'success'"
                size="lg">Request</b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
import Swal from 'sweetalert2'
import { clientAdminMethods } from '@/state/helpers'
export default {
    props:{
        client_revision_id:{
            required: true,
        }
    },
    data:() => ({
        reason_text: '',
        name: '',
        email: '',
    }),
    computed:{
        disableButton(){
            if(this.reason_text === '' || this.email === '' || this.name === ''){
                return true;
            }
            else{
                return false;
            }
        }
    },
    methods:{
        ...clientAdminMethods,
        saveRequest(){
            let params = {
                client_revision_id:this.client_revision_id,
                copy_holder_name: this.name,
                copy_holder_email: this.email,
                reason_for_copy: this.reason_text,
            }
            this.requestSopDistribution(params)
            .then(()=>{
                Swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'success', title:'Request Sent!', customClass: {     popup: 'success-toast' }, showConfirmButton: false, timer: 2500, timerProgressBar: true});
                this.$bvModal.hide('requestsModal');
            })
        }
    },
    mounted(){},
}
</script>

<style>

</style>